import tools from './tools'
import axios from 'axios'
import config from './config'
import router from '../router'
import {Message} from 'iview'


//引用base64解码
let Base64 = require('js-base64').Base64;
let longinFnData = ''

/* 传入token值判断token是否已经过期
 * @returns boolean 
 */
let isExp = () => {
  let timeNow = new Date().getTime();
  let token = tools.getSession('token');
  let refreshToken = tools.getSession('refreshToken');
  let isExp = false;//token是否有效 false 失效 true 有效
  let refreshIsExp = false;//refreshInfo是否有效 false 失效 true 有效
  let firstVali = true;//检查是否验证

  if(token){
    let info = token.split('.')[1];
    let expTime = JSON.parse(Base64.decode(info)).exp;
    isExp =  expTime * 1000 >= timeNow ? true : false;
  }else{
    return false;
  }
  

  if(isExp === false){//如果token过期，则检验refreshInfo是否过期
    let refreshInfo = refreshToken.split('.')[1];
    let refreshExpTime = JSON.parse(Base64.decode(refreshInfo)).exp;
    refreshIsExp =  refreshExpTime * 1000 >= timeNow ? true:false;
    firstVali = false;
  }else{
    return true;
  }
  
   if(refreshIsExp && firstVali == false){//如果refreshInfo，则请求接口刷新
    if(window.refreshToken != 1){
      window.refreshToken = 1;
      // console.log(333)
      let data = {
        params:{refreshToken:refreshToken}
      };
      // console.log(444)
      getrNewToken(config.urlArray.refreshToken,data,2);
    }
    return true;
  }
  
  return true

}

/*请求接口获取token
 * @param url string token接口
 * @param data object 传入的数据对象
 * @param type int 类型 1获取token 2刷新token
 */
let getrNewToken = (url, data, type, fn)=> {
  fn = fn || function(){}
    axios.get(url, data).then(function(response) {
    if(response.data.code === 1){
      tools.setSession('uInfo',response.data.data);
      tools.setSession('token',response.data.data.token);
      tools.setSession('refreshToken',response.data.data.token);
      window.refreshToken = 2;
    }
 
  }).catch(function (error) {
    //消息弹出框
    Message.error('登录失败');
  });
}

/*请求接口获取token
 * @param url string token接口
 * @param data object 传入的数据对象
 * @param type int 类型 1获取token 2刷新token
 */
let getNewToken = (url, data, type, fn)=> {
  fn = fn || function(){}
    axios.post(url, data).then(function(response) {
    if(response.data.code === 1){
      tools.setSession('uInfo',response.data.data);
      tools.setSession('token',response.data.data.token);
      tools.setSession('refreshToken',response.data.data.token);
      window.refreshToken = 2;
    }
    if(type === 1){
      if(response.data.code == 0){
        Message.error({
          content:response.data.message,
          duration:1.5,
          onClose: ()=>{
              fn()
          }
        });
      }else if(response.data.code == 1){
        Message.success({
          content:response.data.message,
          duration:1.5,
          onClose: ()=>{router.push({name:'home'})}
        });
      }
      
    }   
  }).catch(function (error) {
    //消息弹出框
    Message.error('登录失败');
  });
}

export default {
  isExp,getNewToken
}